import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

import { Pagenation } from '../../../_component/pagenation';

export function AdminPublish() {
  const [items, setItems] = useState<any[]>([]);
  const [
    pageInfo = { total: 10, rowCount: 10, page: 1, totalPages: 1 },
    setPageInfo,
  ] = useState<any>();
  // const [meta, setMeta] = useState<any>({});
  // const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchText, setSearchText] = useState<string>('');
  const dispatch = useDispatch();
  const history = useHistory();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
    getBoardList();
  }, []);

  const getBoardList = async () => {
    if (searchText.length === 0) {
      await server
        .getAllPublication(pageInfo.page, pageInfo.rowCount)
        .then((payload) => {
          setItems(payload.items);
          const { meta } = payload;
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else {
      await server
        .searchPublication(pageInfo.page, pageInfo.rowCount, searchText)
        .then((payload) => {
          setItems(payload.items);
          const { meta } = payload;
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
        });
    }
  };

  const onClickDelete = async (id: any) => {
    if (window.confirm('해당 출판문의를 삭제하시겠습니까?')) {
      await server
        .deletePublication(id)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: `서버로부터 응답이 없습니다.` }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: `파라미터 오류` }));
          } else {
            dispatch(toast.info({ message: '해당 출판문의가 삭제되었습니다.' }));
            getBoardList();
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  const onClickPage = async (pageParam: any) => {
    if (searchText.length !== 0) {
      await server
        .searchPublication(pageParam.page, pageParam.rowCount, searchText)
        .then((payload) => {
          setItems(payload.items);
          const { meta } = payload;
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
        })
        .catch((error) => {
          console.log('검색실패 error', error);
        });
    } else {
      await server
        .getAllPublication(pageParam.page, pageParam.rowCount)
        .then((payload) => {
          setItems(payload.items);
          const { meta } = payload;
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  const rowDate = () => {
    return items.map((item: any) => (
      <ul className="row" key={item.id}>
        <li className="counter">{item.id}</li>
        <li className="user-name">{item.name}</li>
        <li className="phone">{item.phone || ''}</li>
        <li className="email">{item.email || ''}</li>
        <li className="day">{new Date(item.writeDate).toLocaleDateString()}</li>
        <li>
          <button className="delete" type="button" onClick={() => onClickDelete(item.id)}>
            삭제
          </button>
        </li>
        <li className="message">
          <pre style={{ width: '100%' }}>{item.contents}</pre>
        </li>
      </ul>
    ));
  };

  return (
    <main className="wrapper list-publish">
      <div className="title">
        <h1>출판문의 (저작자 전용)</h1>
      </div>
      <div className="content">
        <div className="table-header">
          <div className="search">
            <input
              type="search"
              placeholder="성함을 입력해주세요."
              onChange={(event) => {
                setSearchText(event.target.value);
              }}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  getBoardList();
                }
              }}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              onClick={getBoardList}
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
          </div>
        </div>
        <div className="table">
          <ul className="row title">
            <li className="counter">번호</li>
            <li className="user-name">이름</li>
            <li className="phone">연락처</li>
            <li className="email">이메일</li>
            <li className="day">신청일</li>
            <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</li>
          </ul>
          {rowDate()}
        </div>
        {pageInfo ? (
          <Pagenation PageInfo={pageInfo} PagenationHandler={onClickPage} IsFirstEndArrow />
        ) : (
          ''
        )}
      </div>
    </main>
  );
}
